import { useTranslation } from "react-i18next"; // Import useTranslation from react-i18next
import axios from "axios";

/**
 * Custom hook for uploading images.
 * @returns {Function} uploadImage - Function to handle image upload.
 */
const useUploadFiles = () => {
  const { t } = useTranslation(); // Get translation function

  const uploadFiles = async (files, sourceType) => {
    const token = localStorage.getItem("token"); // Get token from localStorage
    const formData = new FormData();

    //check if files are empty
    if (!files || files.length === 0) {
      throw new Error(t("noFiles")); // Throw an error if no files are uploaded
    } else console.log("files:", files.length);
    // Append each file to the FormData object
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    formData.append("sourceType", sourceType); // Indicate the source of the upload

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/upload.php`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Set content type for file upload
          },
        }
      );
      return response.data; // Return uploaded file names
    } catch (error) {
      console.error("Error uploading image:", error);
      throw new Error(t("uploadFailed")); // Throw an error if upload fails
    }
  };

  return { uploadFiles }; // Return the uploadImage function
};

export default useUploadFiles;
